{
  "tabs": {
    "chat": "Kōrerorero",
    "reminders": "Whakamōhiotanga",
    "calendar": "Maramataka",
    "settings": "Tautuhinga"
  },
  "common": {
    "cancel": "Whakakore",
    "save": "Tiaki",
    "confirm": "Whakau",
    "delete": "Mukua",
    "back": "Hoki",
    "close": "Katia",
    "edit": "Whakatika",
    "search": "Rapu",
    "all": "Katoa",
    "loading": "Tārewa...",
    "error": "Kua hapa tētahi mea",
    "notFound": "Kāore i kitea",
    "tryAgain": "Tēnā, whakamātau anō",
    "retry": "Whakamātau anō",
    "undo": "Whakahokia",
    "pullToRefresh": "Tōhia kia whakahou",
    "justNow": "ināianei anake"
  },
  "auth": {
    "welcome": "Nau mai ki FishMemory",
    "tagline": "Tō āwhina whakamōhiotanga WhatsApp, kei tō pākete ināianei.",
    "subtitle": "Tō āwhina whakamōhiotanga WhatsApp, kei tō pākete ināianei.",
    "phoneLabel": "Tō nama WhatsApp",
    "phoneHint": "Ka tukuna he waehere whakamana mā WhatsApp",
    "invalidPhone": "Tēnā, tāuru he nama waea tika",
    "continue": "Haere tonu",
    "enterPhone": "Tāuru tō nama WhatsApp",
    "phonePlaceholder": "Nama waea",
    "sendCode": "Tukuna te Waehere",
    "verifyTitle": "Whakamana i tō nama",
    "otpSentTo": "Kua tukuna he waehere 6-matua ki {{phone}} mā WhatsApp",
    "enterFullCode": "Tēnā, tāuru ngā matua 6 katoa",
    "invalidOtp": "He waehere hē. Tēnā, whakamātau anō.",
    "otpFailed": "Kua hapa te tuku waehere. Whakamātau anō.",
    "otpResent": "Kua tukuna anō te waehere",
    "resendIn": "Tukuna anō i roto i te {{seconds}}h",
    "resendCode": "Tukuna anō te waehere",
    "enterOtp": "Tāuru te waehere i tukuna ki tō WhatsApp",
    "verify": "Whakamana",
    "resend": "Tukuna anō te waehere",
    "wrongNumber": "He nama hē?",
    "backToPhone": "Hoki ki te nama",
    "editPhone": "Whakatika nama waea",
    "error": "Hapa",
    "setupTitle": "Me whakarite",
    "setupSubtitle": "Ka taea e koe te huri i ēnei ā muri ake i ngā Tautuhinga",
    "namePlaceholder": "Tō ingoa",
    "letsGo": "Whakakī i te whakarite",
    "skipForNow": "Tāwharau mō tēnei wā"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Tāruatia he karere...",
    "inputPlaceholder": "Tāruatia he karere...",
    "typing": "Kei te tārua a FishMemory...",
    "online": "I runga ipurangi",
    "connecting": "Kei te hono...",
    "reconnecting": "Kei te hono anō...",
    "offline": "Kāore i runga ipurangi",
    "empty": "Tīmata i te kōrero",
    "emptyHint": "Waihangahia he whakamōhiotanga, tirohia tō mahere, pātai hoki mō te āwhina.",
    "emptyAction": "Tukuna he whakamōhiotanga tauira",
    "actions": "Ngā mahi kōrerorero",
    "keep": "Tiakina ngā karere",
    "clearTitle": "Mukua te kōrerorero",
    "clearConfirm": "Mukua ngā karere katoa i tēnei pūrere? Kāore e taea te whakahoki.",
    "clear": "Mukua te kōrerorero",
    "optionSelected": "Kōwhiria: {{label}}",
    "sendingSelection": "E tuku ana...",
    "connectionLost": "Kei te hono anō..."
  },
  "reminders": {
    "title": "Āku Whakamōhiotanga",
    "active": "Mahi",
    "today": "Ināianei",
    "thisWeek": "I tēnei Wiki",
    "history": "Hītori",
    "items": "taonga",
    "emptyTitle": "Kāore he whakamōhiotanga anō",
    "emptySubtitle": "Waihangahia tētahi i te kōrerorero, ka puta ki konei.",
    "emptyAction": "Whakatuwheratia te kōrerorero",
    "filterActive": "Mahi",
    "filterToday": "Ināianei",
    "filterWeek": "I tēnei Wiki",
    "filterHistory": "Hītori",
    "emptyState": "Kāore he whakamōhiotanga. Tīmatahia te kōrerorero!",
    "swipeDone": "Kua oti",
    "swipeSnooze": "Whakaroa",
    "swipeDelete": "Mukua",
    "search": "Rapu whakamōhiotanga...",
    "upcoming": "E heke mai ana",
    "completed": "Kua oti",
    "overdue": "Kua hēke te wā",
    "tomorrow": "Āpōpō",
    "synced": "Kua tukutahi {{value}}",
    "swipeHint": "Tōhia he whakamōhiotanga mō ētahi atu mahi",
    "noResults": "Kāore he whakamōhiotanga e hāngai ana ki tō rapu",
    "noResultsHint": "Whakamātau i tētahi kupu kē, kia māmā rānei te rapu",
    "deleteAllFailed": "Kua hapa te muku i ngā whakamōhiotanga katoa"
  },
  "calendar": {
    "title": "Maramataka",
    "today": "Ināianei",
    "tomorrow": "Āpōpō",
    "completed": "kua oti",
    "noEvents": "Kāore he kaupapa",
    "noEventsSubtitle": "Kōwhiria he rā kia kite i ngā whakamōhiotanga me ngā kaupapa maramataka.",
    "googleEvent": "Maramataka Google",
    "legendActive": "Mahi",
    "legendRecurring": "Ka hoki anō",
    "legendDone": "Kua oti",
    "legendGoogle": "Google",
    "previousMonth": "Marama o mua",
    "nextMonth": "Marama e whai ake",
    "previousYear": "Tau o mua",
    "nextYear": "Tau e whai ake",
    "goToToday": "Haere ki ināianei",
    "all": "Katoa",
    "active": "Mahi",
    "done": "Kua oti",
    "paused": "Kua whakatā"
  },
  "settings": {
    "title": "Tautuhinga",
    "profile": "Kōtaha",
    "name": "Ingoa Whakaatu",
    "enterName": "Tāuru tō ingoa",
    "language": "Reo",
    "uiLanguage": "Reo taupānga",
    "uiLanguageHelp": "Ka huri i te atanga taupānga, ngā tapanga maramataka, me te aronga whakarite i tēnei pūrere anake.",
    "serverLanguage": "Reo kōrerorero",
    "serverLanguageHelp": "Ka huri i te reo e whakamahia ana e ngā whakahoki a te tūmau me ngā karere whakamōhiotanga mō tō pūkete.",
    "timezone": "Wāhi wā",
    "currentTimezone": "Wāhi wā o nāianei",
    "timezoneHelp": "Ka whakaatuhia ngā wā whakamōhiotanga katoa mā tēnei wāhi wā.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Tiaki wāhi wā",
    "timezoneSaved": "Kua whakahoutia te wāhi wā",
    "detect": "Tirohia",
    "detectFailed": "Kāore i taea te kite i te wāhi wā",
    "autoDetect": "Aunoa mā GPS",
    "notifications": "Whakamōhiotanga",
    "notificationsHelp": "Ko ngā whakamōhiotanga whai muri e whakahaere ana i ngā whakatūpato anō i muri i te tuku whakamōhiotanga. Kei te whakahaere tonu ngā whakaaetanga whakamōhiotanga pūrere i ngā tautuhinga waea.",
    "pushEnabled": "Whakamōhiotanga Pūtāhui",
    "autoDoneOnFire": "Tōia hei oti inā ka puta",
    "autoDoneOnFireDesc": "Ki te kore e whakahohea, ka noho ngā whakamōhiotanga hei mahi kia tohu koe hei oti.",
    "googleCalendar": "Maramataka Google",
    "google": "Maramataka Google",
    "googleConnected": "Kua hono",
    "googleDisconnected": "Kāore i te hono",
    "googleConnectedHelp": "Ka taea te tukutahi aunoa ngā whakamōhiotanga hou ki tō maramataka.",
    "googleDisconnectedHelp": "Honoa te Maramataka Google kia ū ngā whakamōhiotanga me ngā kaupapa.",
    "googleConnectFailed": "Kua hapa te hono ki te Maramataka Google",
    "connected": "Kua hono",
    "disconnected": "Kāore i te hono",
    "connect": "Hono",
    "disconnect": "Wetewete",
    "autoSync": "Tukutahi aunoa i ngā whakamōhiotanga hou",
    "autosync": "Tukutahi aunoa i ngā whakamōhiotanga hou",
    "subscription": "Rēhita",
    "trialUsed": "Whakamātautau: {{used}}/{{total}} kua whakamahia",
    "trialStatus": "Kei te wātea te whakamātautau",
    "activeStatus": "Rēhita kaha",
    "expiredStatus": "Kua pau te rēhita",
    "unsubscribedStatus": "Kāore i te rēhita",
    "about": "Mō",
    "version": "Putanga",
    "logout": "Rēhita Wātea",
    "logoutTitle": "Rēhita Wātea",
    "logoutConfirm": "E tino hiahia ana koe ki te rēhita wātea?",
    "noName": "Kāore he ingoa kua tautuhia",
    "serverConnection": "Hononga tūmau",
    "serverUrl": "URL tūmau",
    "serverEdit": "Whakatika",
    "saveReconnect": "Tiaki, hono anō",
    "resetDefault": "Whakaara ki te taunoa",
    "invalidServerUrlTitle": "URL tūmau hē",
    "invalidServerUrlMessage": "Tāuru he URL tūmau http, https rānei tika, hei tauira https://example.com",
    "uiLanguageChangeFailed": "Kua hapa te huringa reo taupānga. Tēnā, whakamātau anō.",
    "serverLanguageChangeFailed": "Kua hapa te huringa reo kōrerorero. Tēnā, whakamātau anō.",
    "timezoneChangeFailed": "Kua hapa te huringa wāhi wā. Tēnā, whakamātau anō.",
    "autoSyncChangeFailed": "Kua hapa te whakahou i te tukutahi aunoa. Tēnā, whakamātau anō.",
    "nameChangeFailed": "Kua hapa te whakahou i te ingoa whakaatu. Tēnā, whakamātau anō.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Ngā taipitopito whakamōhiotanga",
    "editTime": "Whakatika Wā",
    "rename": "Whakainoa anō",
    "snooze": "Whakaroa",
    "snooze15": "Whakaroa 15 meneti",
    "pause": "Whakatā",
    "pauseReminder": "Whakatā whakamōhiotanga",
    "resume": "Whakakā",
    "resumeReminder": "Whakakā whakamōhiotanga",
    "skip": "Tāwharau Ake",
    "skipOccurrence": "Tāwharau tēnei wāhanga",
    "syncGoogle": "Tukutahi ki Google",
    "delete": "Mukua",
    "deleteTitle": "Mukua Whakamōhiotanga",
    "deleteConfirm": "Ka mukua tēnei whakamōhiotanga mō ake tonu atu.",
    "deleteRecurringTitle": "Mukua Whakamōhiotanga Ka hoki anō",
    "deleteRecurringMessage": "Kei te hiahia koe ki te tāwharau tēnei wāhanga, ki te muku rānei i te raupapa katoa?",
    "deleteThisOccurrence": "Tāwharau tēnei wāhanga",
    "deleteEntireSeries": "Mukua te Raupapa Katoa",
    "done": "Kua oti",
    "markDone": "Tohua hei oti",
    "undo": "Whakahokia",
    "undoPrompt": "Me mahi anō? Whakahokia ināianei.",
    "recurring": "Ka hoki anō",
    "nextRun": "Haere ake",
    "oneTime": "Kotahi anake",
    "pending": "E tatari ana",
    "sent": "Kua tukuna",
    "paused": "Kua whakatā",
    "active": "Mahi",
    "snoozed": "Kua whakaroa",
    "localTime": "Whakaatuhia i tō wā rohe",
    "recurrence": "Te hoki anō",
    "created": "I hangaia",
    "tags": "Tānga",
    "fireCount": "Ngā wā i puta",
    "actions": "Ngā mahi",
    "none": "Kāore",
    "snoozeFailed": "Kua hapa te whakaroa i te whakamōhiotanga",
    "pauseFailed": "Kua hapa te whakatā i te whakamōhiotanga",
    "resumeFailed": "Kua hapa te whakakā i te whakamōhiotanga",
    "skipFailed": "Kua hapa te tāwharau i te whakamōhiotanga",
    "doneFailed": "Kua hapa te tohu i te whakamōhiotanga hei oti",
    "undoFailed": "Kua hapa te whakahoki i te āhua o te whakamōhiotanga",
    "deleteFailed": "Kua hapa te muku i te whakamōhiotanga",
    "rescheduleTitle": "Whakahōu wā?",
    "rescheduleMsg": "Kua hēke te wā o tēnei whakamōhiotanga. Kei te hiahia koe ki te whakahōu i te wā?",
    "reschedule15": "I roto i te 15 meneti",
    "reschedule60": "I roto i te 1 haora",
    "keepOverdue": "Tiaki pēnei tonu"
  },
  "onboarding": {
    "slide1Title": "Nau mai ki FishMemory",
    "slide1Sub": "Tō āwhina whakamōhiotanga whaiaro — mā WhatsApp, mō tō pākete.",
    "slide2Title": "Kōrero noa iho",
    "slide2Sub": "Tāruatia ngā whakamōhiotanga pēnei i tō whakaaro: \"Whakamōhiotia au ki te waea atu ki a māmā āpōpō i te 3pm\" — mā mātou e whakahaere te toenga.",
    "slide3Title": "Kaua e ngaro i tētahi mea",
    "slide3Sub": "Whiwhi whakamōhiotanga i te wā tika, whakaritea ki ngā tānga, me noho ki runga i ngā mea katoa e hira ana.",
    "getStarted": "Tīmata",
    "next": "A muri",
    "firstReminderTitle": "Waihangahia tō whakamōhiotanga tuatahi!",
    "firstReminderHint": "Whakamātau tāruatia he mea pēnei:",
    "firstReminderExample": "Whakamōhiotia au ki te inu wai āpōpō i te 9 AM",
    "gotIt": "Kua mārama!",
    "notifRationaleTitle": "Noho i te wā tika",
    "notifRationaleBody": "Me whai whakamōhiotanga a FishMemory hei whakamōhiotanga i a koe i te wā tika. Ka riro noa iho ngā whakatūpato mō ngā whakamōhiotanga i hangaia e koe.",
    "notifRationaleAllow": "Whakahohe Whakamōhiotanga",
    "notifRationaleLater": "Tērā pea ā muri ake",
    "swipeHint": "Tō ki te taha matau mō ngā mahi tere →",
    "calendarDragHint": "Tō kia whānui ake ↕"
  }
}
